import React from 'react';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import {
    InputLabel,
    MenuItem,
    Select as MuiSelect,
    SelectProps as MuiSelectProps,
    FormControl, Checkbox, ListItemText,
} from '@material-ui/core';

export type SelectOption = {
    text: string,
    value: string,
};

type SelectProps = MuiSelectProps & {
    labelId: string,
    label: string,
    options: Array<SelectOption>,
    placeholderOption?: SelectOption,
};

Select.defaultProps = {
    placeholderOption: undefined,
};

const useStyle = makeStyles((theme: Theme) => createStyles({
    root: {

    },
}));

function Select(props: SelectProps): React.ReactElement {
    const {
        labelId,
        label,
        options,
        placeholderOption,
        multiple,
        value,
        required,
        ...selectProps
    } = props;
    const classes = useStyle();

    return (
        <FormControl className="" variant="outlined">
            <InputLabel shrink={placeholderOption ? true : undefined} id={labelId} required={required}>{label}</InputLabel>
            <MuiSelect
                labelId={labelId}
                label={label}
                displayEmpty={Boolean(placeholderOption)}
                multiple={multiple}
                value={value}
                renderValue={(selected) => {
                    if (multiple) {
                        return (selected as string[])
                            .map((v) => options.find((o) => o.value === v)?.text || '')
                            .filter((v) => v)
                            .join(',');
                    }

                    if (placeholderOption && placeholderOption.value.toString() === (selected as string).toString()) {
                        return placeholderOption.text;
                    }

                    return options.find((o) => o.value.toString() === (selected as string).toString())?.text || '';
                }}
                required={required}
                {...selectProps}
            >
                {placeholderOption ? (
                    <MenuItem value={placeholderOption.value}>{placeholderOption.text}</MenuItem>
                ) : null}
                {options.map((option) => (multiple ? (
                    <MenuItem key={option.value} value={option.value}>
                        <Checkbox checked={(value as string[]).findIndex((item) => item === option.value) > -1} />
                        <ListItemText primary={option.text} />
                    </MenuItem>
                ) : (
                    <MenuItem key={option.value} value={option.value}>{option.text}</MenuItem>
                )))}
            </MuiSelect>
        </FormControl>
    );
}

export { Select };
